/**
 * @description usage capitalize('username')
 * @param s
 */
const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
export default capitalize;
